export default __webpack_public_path__ + "static/media/gallery-8.a4febf3f.jpg";